export default __webpack_public_path__ + "static/media/facade.5dad7538.png";